import type { FetchResponseType, PaginationParams, PaginationResponse } from '@/server/request/types'
import { useApiFetch } from '@/server/request'
import type { ComplaintSearchResponse, HomeNewsPageResponse, NewsColumnPageResponse } from '~/server/types'

export function searchComplaintApi(params: PaginationParams & { title: string }) {
  return useApiFetch<FetchResponseType<PaginationResponse<ComplaintSearchResponse[]>>>({
    url: 'webportal/base/search/esComplain',
    params,
  })
}

export function searchArticleApi(params: PaginationParams & { title: string }) {
  return useApiFetch<FetchResponseType<PaginationResponse<NewsColumnPageResponse[]>>>({
    url: '/webportal/base/search/esArticle',
    params,
  })
}
